import { query } from 'bitecs';
import { destroyEntity, kill } from '@src/ecs/archetypes';
import { Dying, DYING_REAP, Lifetime, Pickup, Sprite } from '@src/ecs/components';
import type { GameSystem } from '@src/ecs/System';
import type { GameContext } from '@src/ecs/world';

const REAP_CAP = 4096;

/** Ticks lifetimes, blinks expiring pickups, and recycles everything flagged Dying. */
export class LifetimeSystem implements GameSystem {
  private ctx!: GameContext;
  private readonly reap = new Int32Array(REAP_CAP);

  init(ctx: GameContext): void {
    this.ctx = ctx;
  }

  destroy(): void {}

  update(dt: number): void {
    const ctx = this.ctx;

    const timed = query(ctx.world, [Lifetime]);
    for (let i = 0; i < timed.length; i++) {
      const eid = timed[i];
      Lifetime.t[eid] -= dt;
      if (Lifetime.t[eid] <= 0) kill(eid);
    }

    const pickups = query(ctx.world, [Pickup, Lifetime, Sprite]);
    const blink = 0.35 + 0.65 * Math.abs(Math.sin(ctx.time * 14));
    for (let i = 0; i < pickups.length; i++) {
      const eid = pickups[i];
      if (Lifetime.t[eid] < 3) Sprite.alpha[eid] = blink;
    }

    // Collect first, then remove: removing while iterating a query is unsafe.
    const dying = query(ctx.world, [Dying]);
    let n = 0;
    for (let i = 0; i < dying.length && n < REAP_CAP; i++) {
      const eid = dying[i];
      if (Dying.flag[eid] === DYING_REAP) this.reap[n++] = eid;
    }
    for (let i = 0; i < n; i++) destroyEntity(ctx, this.reap[i]);
  }
}
